import { render, staticRenderFns } from "./AppointmentsView.vue?vue&type=template&id=62991d28&scoped=true&"
import script from "./AppointmentsView.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsView.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentsView.vue?vue&type=style&index=0&id=62991d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62991d28",
  null
  
)

export default component.exports